export default {
  loading: false,
  item: null
}